<!-- 消息一览 -->
<template>
		<div class="rightInner">
			<div class="between title">
				<div class="titleLeft">
					<div class="titleLine"></div>
					{{$t('mypages.messages.title')}}
				</div>
				<div class="titleRight">{{$t('mypages.messages.mark_all_read')}}</div>
			</div>
			
			<ul class="tabsArea">
				<li :class="{active: tabIdx == 1}" @click="tabClick(1)">{{$t('mypages.messages.tab_1_month')}}</li>
				<li :class="{active: tabIdx == 2}" @click="tabClick(2)">{{$t('mypages.messages.tab_3_months')}}</li>
				<li :class="{active: tabIdx == 3}" @click="tabClick(3)">{{$t('mypages.messages.tab_1_year')}}</li>
				<li :class="{active: tabIdx == 4}" @click="tabClick(4)">{{$t('mypages.messages.tab_3_years')}}</li>
			</ul>
			<div class="card" v-for="(item,index) in messageInfo">
				<div class="between">
					<div class="cardTitle">
						<div class="cir"></div>
						<div>{{item.title}}</div>
					</div>
				
					<div>{{item.gmt_create}}</div>
				</div>
				<div>{{item.content}}</div>
			</div>
			<div class="paginationArea">
				<PaginationVue :TotalCount="totalcount" :pageSize="10" @pageChenged="handlePage"></PaginationVue>
			</div>
		</div>
</template>

<script>
	import PaginationVue from '../../components/pagination.vue';
	export default{	
		components:{
			PaginationVue
		},
		data(){
			return {
				allItems:['1','2','3','4','5','6','7','8','9','10','11','12','13','14'],
				tabIdx:1,
				messageInfo:[],
				pageIndex:1,
				totalcount:1,
			}
		},
		created() {
			this.GetMessageInfo();
		},
		methods:{
			tabClick(idx){
				this.tabIdx = idx;
				this.GetMessageInfo();
			},
			GetMessageInfo()
			{
				this.$scUtil.axiosPost(this, 'MessageApi/GetMessageList', {
					userName: localStorage.getItem('username'),
					type:this.tabIdx ,
					pageIndex:this.pageIndex,
					pageSize:10
				}, res => {
					//console.log(res.code);
					if (res.code == 100) {
						this.messageInfo=res.data;
						this.totalcount=res.totalcount;
					}
				
				});
			},
			handlePage(message) {
				console.log(message);
				this.pageIndex = message;
				this.GetMessageInfo();
			},
		}		
	}
</script>

<style scoped>
	.rightInner{
		width: 958px;	
	}
	
	
	.title{
		display:flex;
		align-items: center;
		height: 52px;
		border-bottom: 1px solid #e2e2e2;
		background-color:#fff;
		padding:0 20px;
		box-sizing: border-box;
	}
	
	.titleLeft{
	   display:flex;
		align-items: center;
		height: 52px;
		font-size: 14px;
		color: #000000;		
		padding-left: 20px;
	}
	
	.titleRight{
		color: #0380fe;
		font-size: 13px;
		cursor: pointer;
	}
	
	.titleLine{
		width: 4px;
		height: 14px;
		background-color: #0380fe;
		margin-right: 15px;
	}
	
	ul.tabsArea{
		display: flex;
		align-items: center;
		padding-left: 40px;
		border-bottom: 1px solid #e2e2e2;
		background-color: #fff;
		margin-bottom: 10px;
	}
	
	ul.tabsArea li{
		list-style: none;
		margin-right: 60px;
		height: 56px;
		line-height: 56px;
		display: flex;
		align-items: flex-end;
		font-size: 14px;
		color: #666666;
		cursor: pointer;
	}
	
	ul.tabsArea li.active{
		color: #0380fe;
		border-bottom: 2px solid #0380fe;
	} 
	
	.card{
		width: 100%;
		background-color: #fff;
		padding: 20px;
		box-sizing: border-box;
		font-size: 12px;
		color: #888888;
		line-height: 30px;
		margin-bottom: 10px;
		cursor: pointer;
	}
	
	.card:hover{
		background-color: #ebf5ff;
	}
	
	.between{
		display: flex;
		justify-content: space-between;
		width:100%;
	}
		
	.cardTitle{
		display: flex;
		align-items: center;
		font-size: 13px;
		color: #000;
	}
	
	.cir{
		width: 3px;
		height: 3px;
		border-radius: 50%;
		background-color: #0380fe;
		margin-right: 5px;
	}
	
	
	.paginationArea{
		display: flex;
		justify-content: center;
		padding: 17px 0;
	}
</style>